<template>
    <form>
    <div class="form-container settings-form">
        <h3 class="block-header mb-6 mt-0" v-if="branchId==''"> QuickBooks Settings</h3>

        <div class="vx-row quickbookrow">
            <div class="vx-col w-full">
                <div class="form_group">
                    <label class="form_label">Client ID<em>*</em></label>
                    <vs-input :key="'ClientId'" class="w-full" name="ClientId" icon-pack="feather" v-validate="'required'"  data-vv-as="Client ID"  icon-after   v-model="qconfig.clientId" />
                    <span class="text-danger text-sm" v-show="errors.has('ClientId')">{{ errors.first("ClientId") }}</span>
                </div>                
            </div>
            <div class="vx-col w-full">
                <div class="form_group">
                    <label class="form_label">Client Secret<em>*</em></label>
                    <vs-input :key="'clientSecret'" class="w-full" name="clientSecret" icon-pack="feather" v-validate="'required'" data-vv-as="Client Secret" icon-after v-model="qconfig.clientSecret" />
                    <span class="text-danger text-sm" v-show="errors.has('clientSecret')">{{ errors.first("clientSecret") }}</span>
                </div>
            </div>
            <div class="vx-col" :class="{'w-50' : branchId=='' , 'w-full' : branchId!='' }">
                <div class="form_group">
                    <label class="form_label">Webhook Authorized Representative Token<em>*</em></label>
                    <vs-input :key="'webhookVerifierToken'" class="w-full" name="webhookVerifierToken" icon-pack="feather" v-validate="'required'" data-vv-as="Webhook Authorized Representative Token" icon-after v-model="qconfig.webhookVerifierToken" />
                    <span class="text-danger text-sm" v-show="errors.has('webhookVerifierToken')">{{ errors.first("webhookVerifierToken") }}</span>
                </div>
            </div>
            <div class="vx-col w-50" v-if="branchId==''">
                <div class="popup-footer form-footer form-footer2">
                    <vs-button color="success" class="save" @click="updateQconfig" type="filled">Save</vs-button>
                </div>
            </div>
        </div>        
    </div>
    <!-- <div class="devider"></div> -->
    <div class="popup-footer form-footer" v-if="branchId!=''">
        <vs-button color="success" class="save" @click="updateQconfig" type="filled">Save</vs-button>
    </div>
    </form>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker";
import Paginate from "vuejs-paginate";
import Datepicker from "vuejs-datepicker-inv";
import Multiselect from "vue-multiselect-inv";
import JQuery from "jquery";

  import _ from "lodash";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
export default {
    props: {
        branchId:{
            type:String,
            default:''
        }
    },
    components: {
        Datepicker,
        DateRangePicker,
        Multiselect,
        Paginate,
    },
    data: () => ({
        qconfig: {
            clientId: "",
            clientSecret: "",
            webhookVerifierToken: "",
            redirectUri: '',
            getRedirectUrl: true,
            branchId:'',
            "responseUri":''
        },
        SubmtRminder: false,
    }),
    watch: {},
    methods: {
        getBranchdetails(){
        let postData = {
          branchId : this.branchId
        }
        
        this.$store.dispatch("commonAction", {"data":postData ,"path":"/branch/details"})
              .then(response => {
                
                if(_.has(response,"QB")){
                     this.qconfig = response["QB"];
                }
                this.qconfig['redirectUri'] = this.$globalgonfig._BASEURL + "/quickbooks/create-token";

              })
               .catch(error => {
                  //this.showToster({message:error,isError:true });
              })
      },
     
        getquickbookConfig() {
            //getTenantId
            

            
            let postData = {tenantId:this.getTenantId};
            this.$store.dispatch("get_tenant_details" ,postData).then((response) => {
               if(_.has(response , "QB")){
                     this.qconfig = response["QB"];
               }
                this.qconfig['redirectUri'] = this.$globalgonfig._BASEURL + "/quickbooks/create-token";
              

            });
          

        },
        updateQconfig() {
             this.$validator.validateAll().then(result => {

            
            if (result ) {
                //"https://anyclap.com";
                 this.qconfig['responseUri'] = this.$globalgonfig._BASEURL + "/quickbooks/status";
                 this.qconfig['redirectUri'] = this.$globalgonfig._APIURL + "/quickbooks/create-token";
                let orgin = window.location.origin;
                this.qconfig['responseUri'] = orgin+ "/quickbooks/status";
                
                let completeOrgin = window.location.href;
                if(completeOrgin.includes('app')){
                    this.qconfig['responseUri'] = orgin+ "/app/quickbooks/status";
                }
                // let orginArray = orgin.split(".");
                // if( orginArray.length==1){

                //       this.qconfig['responseUri'] = orgin+ "/app/quickbooks/status";

                // }
                
                this.qconfig['getRedirectUrl'] = true;
                if(this.branchId && this.branchId!=''){
                    this.qconfig['branchId'] =this.branchId;
                    

                }

                this.$store
                    .dispatch("updategetQuickBookConfig", this.qconfig)
                    .then((response) => {
                        
                        this.showToster({message:response.message,isError:false });
                        this.SubmtRminder = false;
                        this.getquickbookConfig();
                        if(_.has(response , "authUri")){
                            setTimeout(() =>{
                                if(this.branchId !=''){
                                    this.$emit('closeMe')
                                }
                                window.open(response["authUri"]);
                            },500)
                            
                        }
                    })
                    .catch((error) => {
                         this.showToster({message:error,isError:true });

                    });
            }
             });
        },
    },

    mounted() {
        this.username = this.$store.state.user.name;
        this.roleId = this.$store.state.user["roleId"][0];
        this.redirectUri = this.$globalgonfig._APIURL + "/quickbooks/create-token";
        this.qconfig['responseUri'] = this.$globalgonfig._BASEURL+"/quickbooks/status"

        if(this.branchId){
            this.getBranchdetails();
        }else{
            this.getquickbookConfig();

        }
        
    },
};
</script>
